import { useRouter } from 'next/navigation';
import { useAuthenticated } from '@/hooks/useAuthenticated';
import { launchSearchExecution } from '@/api/requests/searchExecutions';
import { getSourcePath } from '@/rewrites';
import { useAccount } from '@/hooks/useAccount';
import { useState } from 'react';
import { useSubscriptionLimits } from '@/hooks/useSubscriptionLimits';
import { useDispatch } from 'react-redux';
import { FeatureType, openModal } from '@/slices/features/modalSlice';

export const useHandleSearch = () => {
  const { isAuthenticated } = useAuthenticated();
  const { refreshCustomer } = useAccount();
  const router = useRouter();
  const [isSearchLoading, setIsSearchLoading] = useState<boolean>(false);
  const { isSearchLimitReached } = useSubscriptionLimits();
  const dispatch = useDispatch();

  const handleSearch = async (item: string) => {
    if (!item.trim()) {
      return;
    }

    if (isSearchLimitReached) {
      dispatch(openModal(FeatureType.MORE_SEARCH_REQUESTS));
      return;
    }

    const data: { [key: string]: any } = { description: item, minScore: 10 };

    setIsSearchLoading(true);
    const response = await launchSearchExecution(data, !isAuthenticated).finally(() => setIsSearchLoading(false));

    const searchExecutionId = response.id;
    if (isAuthenticated) {
      refreshCustomer();
    }
    router.push(getSourcePath(`/search`) + `/${searchExecutionId}`);
  };

  return { handleSearch, isSearchLoading };
};
